import { FullMetadataElement } from './useAddMetadataElementToCanvas';
import { ConfigurationType } from '../../../documentation/dependencies/types';
import { colorPickerColors } from '../../../common/color-picker/colorPickerColors';

const metadataColorsAndIconsTypeMap = {
  [ConfigurationType.apexClasses]: {
    color: colorPickerColors.Blue,
    icon: 'robot',
  },
  [ConfigurationType.apexTriggers]: {
    color: colorPickerColors.Sky100,
    icon: 'record_update',
  },
  [ConfigurationType.fields]: {
    color: colorPickerColors.Lemon,
    icon: 'field_sales',
  },
  [ConfigurationType.objects]: {
    color: colorPickerColors.Mint,
    icon: 'sobject',
  },
  [ConfigurationType.flows]: {
    color: colorPickerColors.Seafoam,
    icon: 'flow',
  },
  [ConfigurationType.workflowRules]: {
    color: colorPickerColors.Sun,
    icon: 'recipe',
  },
  [ConfigurationType.layouts]: {
    color: colorPickerColors.Grey150,
    icon: 'record',
  },
  ['LightningPage']: {
    color: colorPickerColors.Lilac,
    icon: 'lightning_usage',
  },
  // Need to confirm this
  ['LightningComponentBundle']: {
    color: colorPickerColors.Lilac,
    icon: 'lightning_component',
  },
  // Need to confirm this
  ['AuraDefinitionBundle']: {
    color: colorPickerColors.Gum,
    icon: 'custom_component_task',
  },
  // Need to confirm this
  ['ApexPage']: {
    color: colorPickerColors.Blush,
    icon: 'visualforce_page',
  },
};

const assignDefaultColorsAndIcons = (metadataElements: FullMetadataElement[]) => {
  metadataElements.forEach((metadataElement) => {
    if (metadataElement.parentType in metadataColorsAndIconsTypeMap) {
      const parentType = metadataElement.parentType as keyof typeof metadataColorsAndIconsTypeMap;
      metadataElement.color = metadataColorsAndIconsTypeMap[parentType].color;
      metadataElement.icon = metadataColorsAndIconsTypeMap[parentType].icon;
    }
  });
};

export default assignDefaultColorsAndIcons;
